export default class LoadMoreItems{
	constructor(el) {

		this.cardContainer = el;

		this.loadMoreButton = this.cardContainer.querySelector('[data-load-more]');

		if(!this.loadMoreButton) {
			return;
		}

		this.remainingPosts = this.cardContainer.querySelector('[data-card-list="remainingposts"]');

		this.loadMoreButton.addEventListener('click', () => {
			// Select all items that are hidden
			let hiddenItems = this.remainingPosts.querySelectorAll('[data-card-item]:not([style*="display: grid"])');

			// Display the next 5 hidden items or less if there are less than 5 hidden items
			for (let i = 0; i < 5 && i < hiddenItems.length; i++) {
			  hiddenItems[i].style.display = 'grid';
			}

			if (hiddenItems.length < 5) {
		  		this.loadMoreButton.classList.add("disabled");
		  		this.loadMoreButton.setAttribute("disabled", true);
			}
		});
	}
}
